import { render } from "./HeroiconsSolidMusicNote.vue?vue&type=template&id=15ae3d7b"
const script = {}

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMusicNote.vue"]])

export default __exports__